import React, { useEffect } from 'react';
import SEOLandingTemplate from '@/components/SEOLandingTemplate';

const EthicalHackingJaipur = () => {
  useEffect(() => {
    document.title = 'Best Ethical Hacking Course in Jaipur | Indian Cyber Club Academy';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Learn ethical hacking in Jaipur with 100% practical training. Offline & online courses, 30K+ students trained, 95% success rate. Expert instructors, live labs, placement support.');
    }
  }, []);

  const content = [
    "Indian Cyber Club Academy offers the most comprehensive ethical hacking course in Jaipur, Rajasthan. With over 30,000 students trained and a 95% success rate, we are India's leading cybersecurity training institute. Our ethical hacking course combines theoretical knowledge with extensive hands-on practice, ensuring you gain real-world skills that employers value.",
    "Located in the heart of Jaipur, our training center provides state-of-the-art facilities for offline learning. For students across India, we also offer live online classes with the same quality of instruction. Our ethical hacking curriculum covers everything from basic networking concepts to advanced penetration testing techniques, making it suitable for both beginners and experienced IT professionals.",
    "What sets our ethical hacking course apart is the practical approach. You'll get access to dedicated lab environments for 30+ days where you can practice real-world hacking scenarios. Learn to think like a hacker to better protect systems and networks. Our instructors are certified professionals with years of industry experience in cybersecurity and ethical hacking.",
    "The course covers critical topics including network scanning, vulnerability assessment, exploitation techniques, web application security, wireless security, social engineering, and more. You'll master industry-standard tools like Kali Linux, Metasploit, Nmap, Burp Suite, Wireshark, and many others. Upon completion, you'll receive an industry-recognized certificate and be prepared for certifications like CEH (Certified Ethical Hacker).",
    "Our placement support program has helped thousands of students land jobs in top companies like TCS, Infosys, Wipro, and more. We provide resume building, interview preparation, and direct connections with hiring partners. The average package for our graduates is 12 LPA, with many achieving even higher salaries.",
    "Whether you're a college student, IT professional looking to upskill, or someone interested in switching to cybersecurity, our ethical hacking course in Jaipur is designed to meet your needs. We offer flexible batch timings, EMI options, and special discounts for students. Join the 340K+ strong Indian Cyber Club community and start your journey to becoming a certified ethical hacker today."
  ];

  const courseHighlights = [
    { title: "100% Practical Training", description: "Learn by doing with hands-on labs and real-world scenarios" },
    { title: "Expert Instructors", description: "Learn from certified professionals with industry experience" },
    { title: "Live Lab Access", description: "30+ days of dedicated lab environment for practice" },
    { title: "Placement Support", description: "Resume building, interview prep, and hiring partner connections" },
    { title: "Flexible Learning", description: "Offline classes in Jaipur or online from anywhere in India" },
    { title: "Industry Certification", description: "Prepare for CEH and other recognized certifications" }
  ];

  const keySkills = [
    "Network Scanning", "Penetration Testing", "Vulnerability Assessment", "Web Application Security",
    "Wireless Security", "Social Engineering", "Malware Analysis", "Digital Forensics",
    "Kali Linux", "Metasploit", "Burp Suite", "Nmap", "Wireshark", "SQLMap",
    "Password Cracking", "Exploit Development", "Report Writing", "Security Auditing"
  ];

  const faqs = [
    {
      question: "Is this ethical hacking course suitable for beginners?",
      answer: "Yes! Our course starts with fundamentals of networking, Linux, and programming before moving to advanced ethical hacking techniques. No prior cybersecurity experience is required."
    },
    {
      question: "What is the duration of the ethical hacking course in Jaipur?",
      answer: "The comprehensive ethical hacking course is 3-6 months depending on the pace you choose. We offer both intensive and regular batches to suit your schedule."
    },
    {
      question: "Do you provide placement assistance after course completion?",
      answer: "Absolutely! We provide comprehensive placement support including resume building, interview preparation, and connections with 500+ hiring partners across India."
    },
    {
      question: "Can I attend classes online if I'm not in Jaipur?",
      answer: "Yes, we offer live online classes with the same instructors and curriculum. Students from all over India can join our online batches."
    },
    {
      question: "What certifications will I be prepared for?",
      answer: "Our course prepares you for industry-recognized certifications like CEH (Certified Ethical Hacker), CompTIA Security+, and OSCP."
    }
  ];

  return (
    <SEOLandingTemplate
      title="Best Ethical Hacking Course"
      subtitle="in Jaipur, Rajasthan"
      metaTitle="Best Ethical Hacking Course in Jaipur | Indian Cyber Club Academy"
      metaDescription="Learn ethical hacking in Jaipur with 100% practical training. Offline & online courses, 30K+ students trained, 95% success rate. Expert instructors, live labs, placement support."
      content={content}
      courseHighlights={courseHighlights}
      keySkills={keySkills}
      faqs={faqs}
    />
  );
};

export default EthicalHackingJaipur;